module.exports = __webpack_public_path__ + "b66b829cfe8f391070c7859b65bc617e.png";